module.exports = __webpack_public_path__ + "media/images/about_us/quote-3b635f7fd1c40ede614daf67e779e38c.svg";